<template>
  <div style="height: 100%; width: 100%" class="p-0 m-0">
    <div class="row h-100 m-0">
      <div class="h-100 scroll" style="width: 250px; color: #565959">
        <div class="row m-1 mt-4 mb-4 text-nowrap">
          <span class="title-lbl">オプションアイテム</span>
        </div>
        <!-- <div class="row">
          <div class="col-auto d-flex flex-row" @click.stop="onClickRecommend">
            <img class="" src="@/assets/acrypro/recommend-icon.svg" />
            <p class="my-auto ms-4 fw-bold" style="cursor: pointer;">おすすめ</p>
          </div>
        </div> -->
        <div class="row mt-3">
          <div class="col-auto d-flex flex-row" @click.stop="onClickFavorite">
            <img class="" src="@/assets/acrypro/favorite-icon.svg" />
            <p class="my-auto ms-4 fw-bold" style="cursor: pointer;">お気に入り</p>
          </div>
        </div>
        <hr class="mb-0" />
        <div class="row">
          <div class="col text-start">
            <p class="fw-bold my-4">全ての商品</p>
            <!-- カテゴリーの表示 -->
            <Accordion
              v-bind:opened="false"
              v-for="genre in this.$store.state.optionManager.genreList"
              :key="genre.text"
              class=""
            >
              <div slot="title">
                <div class="row m-0 p-0 justify-content-between">
                  <div
                    class="col-12 m-0 p-0 text-start listText"
                    style="white-space: nowrap"
                  >
                    {{ genre.genreName }} ({{ genre.num }})
                  </div>
                </div>
              </div>
              <div class="js-accordion--body text-start ps-3" slot="body">
                <p
                  v-for="subGenre in genre.subGenre"
                  :key="subGenre.text"
                  @click.stop="onClickSubGenre(genre.genreName,subGenre.subGenreName)"
                  class="listText sub-genre-text"
                >
                  {{ subGenre.subGenreName }} ({{ subGenre.num }})
                </p>
              </div>
            </Accordion>
          </div>
        </div>
      </div>

      <!-- オプション品の表示 -->
      <div class="col h-100 scroll">
        <div class="row justify-content-start">
          <div class="col-12 d-flex mt-4">
            <div class="position-relative">
              <!-- <i class="bi bi-search position-absolute" style="top:8px;left:10px"></i> -->
              <input
                type="text"
                class="find-input"
                v-model="itemName"
                placeholder="アイテム名"
              />
            </div>
            <button class="bg-transparent border-0" @click="onClickSearch">
              <img
                src="@/assets/acrypro/search.svg"
                class=""
                style="width: 35px; height: 35px"
              />
            </button>
          </div>
          <div class="col-12 text-start" style="margin-top:80px">
            <p>{{ this.listTitle }}</p>
            <hr class="mt-4">
          </div>
          <div
            class="col-auto"
            v-for="item in getSelectGenreItemList"
            :key="item.productId"
            @click="onClickOption(item.productId)"
          >
            <div class="d-flex flex-column" style="width: 180px; height: 360px">
              <img :src="item.imageUrl" class="w-100 img-fluid border border-gray" />
              <div
                class="img-fluid my-2 position-relative"
                style="width: 30px; height: 30px"
                @click.stop="onClickFavoriteBtn(item.productId)">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 41 40" fill="none" class="hartframe" :class="{'hartframe-select-color':isFavorite(item.productId)}">
                <circle cx="20.5" cy="20" r="19.5"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 31 30" fill="none" class="hart" style="top: 6px;" :class="{'hart-select-color':isFavorite(item.productId)}">
                <path d="M15.4996 26.5469L13.7273 24.9336C7.4329 19.2258 3.27734 15.4614 3.27734 10.8414C3.27734 7.07692 6.23512 4.11914 9.99957 4.11914C12.1262 4.11914 14.1673 5.10914 15.4996 6.67359C16.8318 5.10914 18.8729 4.11914 20.9996 4.11914C24.764 4.11914 27.7218 7.07692 27.7218 10.8414C27.7218 15.4614 23.5662 19.2258 17.2718 24.9458L15.4996 26.5469Z"/>
                </svg>
              </div>
              <p>{{ item.title }}</p>
              <p class="text-start fw-bold mt-auto">¥{{ item.priceBase }}(税別)</p>
            </div>
          </div>
        </div>
        <!-- 
        <div class="card-columns">
          <div class="card text-start"      
            v-for="item in getSelectGenreItemList"
            :key="item.productId"
            @click="onClickOption(item.productId)">
            <img class="img-fluid ms-3" src="@/assets/acrypro/hearticon_off.png" style="width:15px; height:15px" :class="{ favorite_color: isFavorite(item.productId) }" @click.stop="onClickFavorite(item.productId)" >
            <img class="img-fluid" v-if="false" src="@/assets/acrypro/hearticon_on.png" style="width:15px; height:15px" :class="{ favorite_color: isFavorite(item.productId) }" @click.stop="onClickFavorite(item.productId)" >
            
            <img  :src="item.imageUrl" />
           </div>
        </div> -->

        <!--        <div class="row option_grid d-block">
          <div
            class="option_grid_cell"
            v-for="item in getSelectGenreItemList"
            :key="item.productId"
            @click="onClickOption(item.productId)"
          >
            <button
              :class="{ favorite_color: isFavorite(item.productId) }"
              style="width: 30px; height: 30px"
              @click.stop="onClickFavorite(item.productId)"
            ></button>
            <img style="width: 130px; height: 130px" :src="item.imageUrl" />
            {{ item }}
          </div>
        </div>
-->

        <!-- オプション品詳細モーダル -->
      </div>
    </div>
    <div v-if="this.isShowModal" class="option_modal_bg" @click="setModal(false)">
      <div class="option_modal" style="min-height:700px;" @click.stop="">
        <div class="row justify-content-end mt-2">
          <div class="col-auto">
            <button class="border-0 bg-transparent mt-2 me-2" @click="setModal(false)">
              <img src="@/assets/acrypro/close.svg">
            </button>
          </div>
        </div>
        <div class="row" style="height: 30%;">
          <div class="col-12 text-center h-100">
            <img
              :src="selectOption.imageUrl"
              class="img-fluid h-100"
            />
          </div>
        </div>
        <div class="row justify-content-center mt-2">
          <div class="col-auto d-flex flex-row">
            <div class="position-relative" @click.stop="onClickFavoriteBtn(selectOption.productId)">
              <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none" class="hartframe" :class="{'hartframe-select-color':isFavorite(selectOption.productId)}">
              <circle cx="20.5" cy="20" r="19.5"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none" class="hart" :class="{'hart-select-color':isFavorite(selectOption.productId)}">
              <path d="M15.4996 26.5469L13.7273 24.9336C7.4329 19.2258 3.27734 15.4614 3.27734 10.8414C3.27734 7.07692 6.23512 4.11914 9.99957 4.11914C12.1262 4.11914 14.1673 5.10914 15.4996 6.67359C16.8318 5.10914 18.8729 4.11914 20.9996 4.11914C24.764 4.11914 27.7218 7.07692 27.7218 10.8414C27.7218 15.4614 23.5662 19.2258 17.2718 24.9458L15.4996 26.5469Z"/>
              </svg>
            </div>
            <p class="my-auto ms-3" style="font-size:22px">¥ {{selectOption.priceBase.toLocaleString() }}</p>
          </div>
        </div>
        <div class="row justify-content-center" style="height: 50%;min-height:300px;margin-top:16px;">
          <div class="modal_info px-5">
            <p v-html="this.adjustInfo(selectOption.info)"></p>
          </div>
          <div class="row justify-content-center bottommenu">
            <div class="col-auto d-flex gap-2">
              <p class="fw-bold my-auto">数量</p>
              <select
                style="width:90px;height:44px;border:lightgray solid 1px"
                name="num_list"
                id="num_list"
                class="ps-3"
                v-model="selectOptionNum"
              >
                <option
                  v-for="num in [...Array(10)].map((_, i) => i + 1)"
                  v-bind:key="num"
                  v-bind:value="num"
                >
                  {{ num }}
                </option>
              </select>
              <button class="m-0 p-1 px-2 ms-4 cart-btn fw-bold" @click="onClickCart">
                カートに入れる
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "CenterViewOption_Ap",
  props: {},
  data: function () {
    return {
      selectGenreName: "",
      selectSubGenreName: "",
      isShowModal: false,
      selectProductId: "",
      genreList: [],
      selectOptionNum: 1,
      itemName: "",
    };
  },
  computed: {
    selectOptionItem(){
      for (var item in this.getSelectGenreItemList) {
        if(item.productId == this.selectProductId) {
          return item
        }
      }
      return null
    },
    listTitle(){
      switch (this.selectSubGenreName) {
        case "Favorite": return "お気に入り"
        case "Recommend": return "おすすめ"
        case "Search": return "検索結果"
        default:
          if (this.selectSubGenreName == ""){
            if (this.selectGenreName != "") {
              return this.selectGenreName
            } else {
              return ""
            }
          } else {
            return `${this.selectGenreName} > ${this.selectSubGenreName}`
          }
      }
    },
    // getGenreList(){
    //   return this.$store.state.optionManager.getGenreList();
    // },
    checkSelectGenre() {
      return (name) => {
        return this.selectGenreName == name;
      };
    },
    getSelectGenreItemList() {
      switch (this.selectSubGenreName) {
        case "Favorite":
          return this.$store.state.optionManager.itemList.filter((item) =>
            this.$store.state.optionManager.favoriteList.some(
              (fav) => fav.productId == item.productId
            )
          );
        case "Recommend":
          return this.$store.state.optionManager.itemList.filter((item) =>
            this.$store.state.optionManager.recommend.some((rcm) => rcm == item.productId)
          );
        case "Search":
          return this.$store.state.optionManager.itemList.filter((item) =>
            (item.title.indexOf(this.itemName) > -1)
          );

        default:
          return this.$store.state.optionManager.itemList.filter(
            (item) => item.subGenre == this.selectSubGenreName
          );
      }
    },
    selectOption() {
      return this.$store.state.optionManager.itemList
        .filter((item) => item.productId == this.selectProductId)
        .shift();
    },
  },
  async created() {
    this.$store.commit("hideRightMenu");

    this.$store.commit("showLoading");

    // this.genreList = this.$store.state.optionManager.genreList;

    await this.$store.state.optionManager.update().catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });

    this.$store.commit("hideLoading");
  },
  components: {
    Accordion,
  },
  methods: {
    onClickSubGenre(genreName,subGenrename) {
      this.selectGenreName = genreName
      this.selectSubGenreName = subGenrename;
      this.setModal(false);
    },

    onClickFavorite() {
      this.selectSubGenreName = "Favorite";
    },

    onClickRecommend() {
      this.selectSubGenreName = "Recommend";
    },

    onClickOption(productId) {
      console.log(productId);
      this.selectProductId = productId;
      this.isShowModal = true;
    },

    // 商品説明の調整
    adjustInfo(text) {
      let tex = text.slice(1).slice(0, -1);
      tex = tex.replace("h3>", "h5>");
      tex = tex.replace("<table", '<table style="display: inline-table;"');
      return tex;
    },

    async onClickFavoriteBtn(productId) {
      if (this.isFavorite(productId)) {
        await this.$store.state.optionManager.deleteFBFavoriteData(productId);
      } else {
        await this.$store.state.optionManager.addFavoriteData(productId);
      }
    },

    isFavorite(productId) {
      for (let i = 0; i < this.$store.state.optionManager.favoriteList.length; ++i) {
        if (this.$store.state.optionManager.favoriteList[i].productId == productId) {
          return true;
        }
      }

      return false;
    },

    setModal(isShow) {
      this.isShowModal = isShow;
      this.selectOptionNum = 1;
    },

    async onClickCart() {
      if (this.selectOptionNum == 0) {
        return;
      }

      let item = this.$store.state.optionManager.itemList
        .filter((item) => item.productId == this.selectProductId)
        .shift();

      this.$store.commit("showLoading");

      await this.$store.state.cartManager
        .addCartOption(
          this.selectProductId,
          item.title,
          this.selectOptionNum,
          item.imageUrl
        )
        .catch((e) => {
          this.$store.commit("hideLoading");
          this.$common.log(e);
          this.$store.commit("showMessage", "エラーが発生しました");
          return;
        });

      Analytics.addToCartOption(this.selectProductId, item.title, this.selectOptionNum, item.priceBase);

      this.$store.commit("hideLoading");
    },

    onClickSearch(){
      this.selectSubGenreName = "Search";
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.genre_cell {
  margin: 1em 1em 1em 0.1em;
  border: 0px #565959;
  border-bottom: 1px;
  font-size: 1.3em;
}

.option_grid {
  height: 100%;
  margin: 0% 10%;
  justify-content: center;

  overflow: scroll;
  overflow-x: hidden;
}

.option_grid_cell {
  position: relative;
  margin: 20px;
  width: 180px;
  height: 265px;
  background-color: #cccccc;
  float: left;
}

.favorite_color {
  background-color: red;
}

.option_modal_bg {
  background-color: rgba(0.5, 0.5, 0.5, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.option_modal {
  position: relative;
  width: 830px;
  height: 85%;
  background-color: white;
  border-radius: 15px;
}

// オプション品の説明文
.modal_info {
  width: 90%;
  height: 80%;
  font-size: 0.9em;
  overflow-y: scroll;
}
.card-columns {
  column-count: 4;
}
.scroll {
  overflow-y: scroll;
}
.bottommenu {
  position: absolute; /*自由に配置する指定*/
  bottom: 15px; /*下寄せの指定*/
  margin: 0;
}
.isSelected {
  background: lightblue;
}
.listText {
  cursor: pointer;
  font-size: 13px;
}
.title-lbl {
  padding: 0px;
  color: var(--primary-main, #8c9bc6);
  text-align: center;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.4px;
}
.find-input {
  width: 300px;
  height: 40px;
  border: $primary-main-color solid 2px;
  border-radius: 24px;
  background-color: transparent;
  padding-left: 15px;
}
.cart-btn {
  width:197px;
  height:40px;
  border-radius: 20px;
  background: $primary-main-color;
  color:white;
  border:transparent;
}
.sub-genre-text {
  color: $primary-main-color;
}
.hartframe{
  stroke: $border-sub-color;
}
.hart{
  stroke: $border-sub-color;
  position: absolute;
  top: 7px;
  left: 5px;
}
.hartframe-select-color{
  fill: #FFF6F6;
  stroke: #FDA1A1;
}

.hart-select-color{
  stroke: #FDA1A1;
  fill: #FDA1A1;
}
</style>
